import type { OsobyFyzickaOsobaDto } from '@gov-nx/api/generated/osoby.types';

export const isAdult = (age: OsobyFyzickaOsobaDto['vek']) =>
	age ? age >= 18 : false;
